// extracted by mini-css-extract-plugin
export default {"media":"B9fMa","image":"ihXl4","body":"TczZr"};